module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkIAAAGFAQMAAAArbA7SAAAAA1BMVEUAAACnej3aAAAAM0lEQVR42u3BMQEAAADCIPuntsYOYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDQAXByAAE2Y+kzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg4.png
// module id = peIc
// module chunks = 2